import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axiosInstance";
import Icon from "../../../components/AppIcon";

const PlatformFeatureAdmin = () => {
  const navigate = useNavigate();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadFeatures = async () => {
    try {
      const res = await api.get("/api/platform-features");
      setFeatures(res.data);
    } catch {
      alert("Failed to load platform features");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFeatures();
  }, []);

  const removeFeature = async (id) => {
    if (!window.confirm("Delete this feature?")) return;
    await api.delete(`/api/platform-features/${id}`);
    loadFeatures();
  };

  const toggle = async (id, field, value) => {
    await api.put(`/api/platform-features/${id}`, {
      [field]: !value
    });
    loadFeatures();
  };

  if (loading) return <p className="text-muted-foreground">Loading...</p>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Platform Features</h1>
        <button
          onClick={() => navigate("/admin/platform-features/new")}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          + Add Feature
        </button>
      </div>

      <div className="bg-card border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted">
            <tr>
              <th className="p-3 text-left">Title</th>
              <th>Icon</th>
              <th>Order</th>
              <th>Home</th>
              <th>About</th>
              <th>Active</th>
              <th className="text-right pr-4">Actions</th>
            </tr>
          </thead>

          <tbody>
            {features.map((f) => (
              <tr key={f._id} className="border-t">
                <td className="p-3 font-medium">{f.title}</td>
                <td>{f.icon}</td>
                <td>{f.order}</td>

                {["showOnHome", "showOnAbout", "isActive"].map((field) => (
                  <td key={field}>
                    <input
                      type="checkbox"
                      checked={f[field]}
                      onChange={() => toggle(f._id, field, f[field])}
                    />
                  </td>
                ))}

                <td className="text-right pr-4 space-x-2">
                  <button
                    onClick={() =>
                      navigate(`/admin/platform-features/${f._id}`)
                    }
                  >
                    <Icon name="Edit" size={18} />
                  </button>
                  <button onClick={() => removeFeature(f._id)}>
                    <Icon name="Trash2" size={18} className="text-red-500" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlatformFeatureAdmin;
